"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
/**
 * This React context can be used within a `Space` to get access
 * to the `ViewPort`.
 *
 * See `SpaceContextType` for the type of the data.
 */
exports.SpaceContext = React.createContext(undefined);
//# sourceMappingURL=SpaceContext.js.map